import React from 'react';
import DatePicker from 'react-datepicker';
import { Search, Calendar, User } from 'lucide-react';
import { SearchForm } from '../types';
import { parseLocalDate } from '../utils';
import 'react-datepicker/dist/react-datepicker.css';

type PeriodSearchFormProps = {
  form: SearchForm;
  errors: Partial<SearchForm>;
  isLoading: boolean;
  onUserIdChange: (value: string) => void;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  onSearch: () => void;
};

export const PeriodSearchForm: React.FC<PeriodSearchFormProps> = ({
  form,
  errors,
  isLoading,
  onUserIdChange,
  onStartDateChange,
  onEndDateChange,
  onSearch,
}) => {
  return (
    <div className="p-6 border-b border-gray-200">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">指定期間を表示</h2>
      
      <div className="space-y-4">
        {/* ユーザID入力 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <User className="inline w-4 h-4 mr-2" />
            ユーザID
          </label>
          <input
            type="text"
            value={form.userId}
            onChange={(e) => onUserIdChange(e.target.value)}
            placeholder="例: 506"
            className={`input-field ${errors.userId ? 'border-red-500' : ''}`}
          />
          {errors.userId && (
            <p className="mt-1 text-sm text-red-600">{errors.userId}</p>
          )}
        </div>

        {/* 開始日選択 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Calendar className="inline w-4 h-4 mr-2" />
            開始日
          </label>
          <DatePicker
            selected={parseLocalDate(form.startDate)}
            onChange={onStartDateChange}
            dateFormat="yyyy-MM-dd"
            placeholderText="YYYY-MM-DD"
            className={`input-field ${errors.startDate ? 'border-red-500' : ''}`}
            maxDate={new Date()}
          />
          {errors.startDate && (
            <p className="mt-1 text-sm text-red-600">{errors.startDate}</p>
          )}
        </div>

        {/* 終了日選択 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Calendar className="inline w-4 h-4 mr-2" />
            終了日
          </label>
          <DatePicker
            selected={parseLocalDate(form.endDate)}
            onChange={onEndDateChange}
            dateFormat="yyyy-MM-dd"
            placeholderText="YYYY-MM-DD"
            className={`input-field ${errors.endDate ? 'border-red-500' : ''}`}
            maxDate={new Date()}
            minDate={form.startDate ? new Date(form.startDate) : undefined}
          />
          {errors.endDate && (
            <p className="mt-1 text-sm text-red-600">{errors.endDate}</p>
          )}
        </div>

        {/* 期間検索ボタン */}
        <button
          onClick={onSearch}
          disabled={isLoading}
          className={`w-full btn-primary flex items-center justify-center ${
            isLoading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          <Search className="w-4 h-4 mr-2" />
          {isLoading ? '検索中...' : '期間検索'}
        </button>
      </div>
    </div>
  );
};
